import classNames from "classnames"
import Icon from "components/Icon"
import colors from "styles/colors"
import { t } from "translations"
import utils from "../modules/utils"
import css from "./AppStats.module.scss"
import { Column, Row } from "./Layout"

const seperator = (
  <div
    className="sep"
    style={{
      display: "block",
      background: colors.cardsBackground,
      width: 2,
      height: 30,
      margin: "0 20px",
    }}
  >
    &nbsp;
  </div>
)

const AppStats = ({ score, reviews, size, downloads, className }) => {
  return (
    <Row className={classNames(className, css.appStats)} align="mc">
      <Column align="mc" gap={2}>
        <h3>{(score || 0).toFixed(1)} ★</h3>
        <h5>
          {utils.abbreviateNumber(reviews)} {t("reviews")}
        </h5>
      </Column>
      {seperator}

      {size && <>
        <Column align="mc" gap={2}>
          <Icon name="downloads" size={22} />
          <h5>{utils.humanFileSize(size)}</h5>
        </Column>
        {seperator}
      </>
      }

      <Column align="mc" gap={2}>
        <h3>{utils.abbreviateNumber(downloads)}+</h3>
        <h5>{t("downloads")}</h5>
      </Column>
    </Row>
  )
}

export default AppStats
